import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AlertTriangleIcon, LucideAngularModule, X } from 'lucide-angular';

@Component({
	standalone: true,
	selector: 'app-integration-warning-banner',
	templateUrl: './integration-warning-banner.component.html',
	imports: [
		RouterLink,
		LucideAngularModule,
	],
})
export class IntegrationWarningBannerComponent {
	@Input() accountingProvider: string;
	@Output() dismissed = new EventEmitter<void>();

	closeBanner(): void {
		this.dismissed.emit();
	}

	get integrationLink(): string {
		return this.accountingProvider 
			? `/admin/external-accounting/${this.accountingProvider.toLowerCase()}`
			: '/admin/external-accounting';
	}

	protected readonly AlertTriangleIcon = AlertTriangleIcon;
	protected readonly X = X;
}
